import { Box } from "@mui/material";
import Header from "../../components/Header";
import InventoryShare from "../../components/InventoryShare";

const Pie =() => {
    return (
        <Box m="20px">
            <Header title="INVENTORY SHARE" subtitle="Visualise your current inventory share here"/>
            <Box height="75vh">
                <InventoryShare/>
            </Box>
        </Box>
    )
}

export default Pie;